var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L11.8 11.8M6.7 12.4C7.44853 12.4 8.18974 12.2526 8.8813 11.9661C9.57285 11.6797 10.2012 11.2598 10.7305 10.7305C11.2598 10.2012 11.6797 9.57285 11.9661 8.8813C12.2526 8.18974 12.4 7.44853 12.4 6.7C12.4 5.95147 12.2526 5.21026 11.9661 4.5187C11.6797 3.82715 11.2598 3.19879 10.7305 2.66949C10.2012 2.1402 9.57285 1.72034 8.8813 1.43389C8.18974 1.14743 7.44853 1 6.7 1C5.18827 1 3.73845 1.60053 2.66949 2.66949C1.60053 3.73845 1 5.18827 1 6.7C1 8.21173 1.60053 9.66155 2.66949 10.7305C3.73845 11.7995 5.18827 12.4 6.7 12.4Z",
    stroke: "#D9DAE0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearchIcon);
export default __webpack_public_path__ + "static/media/newSearchIcon.724c0865d629adbd2ebc1697d2231b49.svg";
export { ForwardRef as ReactComponent };